import { FuncionalidadeContainer } from "../styles"
import ContasCorrentesCrud from "./ContasCorrentesCrud"
import Empregados from "./Empregados"
import Fornecedores from "./Fornecedores"
import TiposDeImposto from "./TiposDeImposto"

const ContasCorrentes = () => (
  <>
    <FuncionalidadeContainer>
      <ContasCorrentesCrud />
    </FuncionalidadeContainer>
    <FuncionalidadeContainer>
      <Fornecedores />
    </FuncionalidadeContainer>
    <FuncionalidadeContainer>
      <TiposDeImposto />
    </FuncionalidadeContainer>
    <FuncionalidadeContainer>
      <Empregados />
    </FuncionalidadeContainer>
  </>
)

export default ContasCorrentes